"use strict";

import * as ProductForm from "components/ProductForm";
import * as Video from "components/Video";
import * as AnchorLinks from "components/AnchorLinks";
import * as Selects from "components/Selects";
import * as ProductMedia from "components/ProductMedia";
document.addEventListener("DOMContentLoaded", function () {
  ProductForm.init();
  Video.init();
  AnchorLinks.init();
  Selects.init();
  ProductMedia.init();
});
